module.exports = __webpack_public_path__ + "img/no-image.99af9f0b.svg";